// eslint-disable-next-line import/prefer-default-export
export const getTranslations = (state, { code }) => state.translations[code];